import React from 'react';
import InlineTextEditor from '@/components/common/InlineTextEditor';

export default function TextEditorSkills(props) {
  return <InlineTextEditor {...props} label='skills' />;
}
